import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { LogoStrip } from "@/components/landing/LogoStrip";
import { Features } from "@/components/landing/Features";
import { Install } from "@/components/landing/Install";
import { Platform } from "@/components/landing/Platform";
import { Band } from "@/components/landing/Band";
import { Testimonials } from "@/components/landing/Testimonials";
import { Proof } from "@/components/landing/Proof";
import { Faq } from "@/components/landing/Faq";
import { Footer } from "@/components/landing/Footer";

function App() {
  return (
    <div className="App bg-ground text-ash min-h-screen antialiased overflow-x-hidden">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <LogoStrip />
        <Features />
        <Install />
        <Platform />
        <Band />
        <Testimonials />
        <Proof />
        <Faq />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
